// CaloriesTable.js
import React, { useState } from 'react';
function CaloriesTable({ caloriesBurned, bmr, maintain, mildLoss, lose, extremeLoss, mildGain, gain, extremeGain }) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status Manajemen Berat Badan</th>
          <th > Kalori (per hari)</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Mempertahankan Berat Badan</td>
          <td>{maintain}</td>
        </tr>
        <tr >
          <td>Penurunan Berat Badan Ringan (0,25 kg/minggu)</td>
          <td>{mildLoss}</td>
        </tr>
        <tr >
          <td>Penurunan Berat Badan (0,5 kg/minggu)</td>
          <td>{lose}</td>
        </tr>
        <tr >
          <td>Penurunan Berat Badan Berlebihan (1 kg/minggu)</td>
          <td>{extremeLoss}</td>
        </tr>
        <tr >
          <td>Kenaikan Berat Badan Ringan (0,25 kg/minggu)</td>
          <td>{mildGain}</td>
        </tr>
        <tr >
          <td>Kenaikan Berat Badan (0,5 kg/minggu)</td>
          <td>{gain}</td>
        </tr>
        <tr >
          <td>Kenaikan Berat Badan Cepat (1 kg/minggu)</td>
          <td>{extremeGain}</td>
        </tr>
        <tr >
          <td colSpan="2">Total Kalori yang Dikonsumsi/Dibakar : {caloriesBurned} (per hari) </td>
        </tr>
        <tr  >
          <td colSpan="2"> Laju Metabolisme Basal BMR adalah : {bmr} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default CaloriesTable;